var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useNavigate, useParams } from "react-router-dom";
import { FormItemTypes } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { ReactComponent as LeftArrow } from '../../../../../assets/images/arrow-left.svg';
import { ReactComponent as LinkSvg } from '../../../../../assets/images/linkIcon.svg';
import { useAppDispatch, useAppSelector } from "../../../../../store/hooks";
import { Download, MoreVert } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Divider } from "@mui/material";
import { showSurface } from "../../../../../redux/awaitedSurfacesSlice";
import ActionMenuList from "../../../../../builderPackage/components/actionsMenuList";
import dayjs from "dayjs";
import { DynamicFormBuilderContainer } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { secondary } from "../../../../../theme/colors";
import { ShareIcon } from "../../../../../assets/images";
import { PrintIconSVG } from "../../../../spareParts/purchaseRequistion/assets/customIcons";
import { PhysicalFormData, PhysicalFormDataMobileView } from "../../../../fieldFailureReports/components/fieldFailureReportCreateForm/PhysicalPhenamena";
import { AdditionalTab } from "../../../../fieldFailureReports/components/fieldFailureReportCreateForm/AdditionalTab";
import { CheckListDataGrid } from "../../../../fieldFailureReports/CheckList/ChecklistDataGrid";
import { getProductDetailsCard } from "../../../../fieldFailureReports/components/fieldFailureReportCreateForm/ProductDetailsCard";
import { getDefectList } from "../../../../jobCardDetails/services/apiCalls";
import WarrantyPartModal from "../../../../fieldFailureReports/components/warrantyPartModal";
import { FieldFailureReportsKeys } from "../../../../fieldFailureReports/services/entity";
import { basicDetailsAndVehicleDetails } from "../../../../fieldFailureReports/components/fieldFailureReportCreateForm/BasicDetailsAndVehicleDetails";
import { HistoryTab } from "./HistoryTab";
import { ChildFF } from "./ChildFFR";
import { FieldFailureReportsGetAPI, getFieldFailureReportsUpdateAPICall } from "../../../services/apiCalls";
var FieldFailureReport = function () {
    var _crud$FieldFailureRep, _crud$FieldFailureRep2;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var id = useParams().id;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var ProductDetailsCard = getProductDetailsCard(lgMode);
    var handBackClick = function () {
        navigate('/areaFieldReports/ffr');
        // dispatch(setReducerState({ key: FieldFailureReportsKeys.get, value: null }))
    };
    var crud = useAppSelector(function (state) { return state.crud; });
    var exportProps = {
        warrantyPartModal: (_crud$FieldFailureRep = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep === void 0 || (_crud$FieldFailureRep = _crud$FieldFailureRep.data) === null || _crud$FieldFailureRep === void 0 ? void 0 : _crud$FieldFailureRep.WarrantyPartData
    };
    var showWarrantyDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!lgMode) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: "Dialog",
                            Component: WarrantyPartModal,
                            containerProps: {
                                fullWidth: true
                            },
                            componentProps: {
                                data: exportProps.warrantyPartModal,
                                id: '87d35889-a535-4bf0-9877-cdd67e62b6e6'
                            }
                        }))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, dispatch(showSurface({
                        type: "Drawer",
                        Component: WarrantyPartModal,
                        // containerProps: { fullWidth: true },
                        componentProps: {
                            data: exportProps.warrantyPartModal,
                            id: '87d35889-a535-4bf0-9877-cdd67e62b6e6'
                        },
                        containerProps: {
                            anchor: 'bottom',
                            PaperProps: {
                                sx: {
                                    width: {
                                        xs: '100%',
                                        sm: '70%',
                                        md: '40%'
                                    },
                                    height: {
                                        xs: '80%',
                                        sm: '100%'
                                    },
                                    borderTopLeftRadius: 16,
                                    borderTopRightRadius: 16
                                }
                            }
                        }
                    }))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var BasicDetailsAndVehicleDetails = basicDetailsAndVehicleDetails((_crud$FieldFailureRep2 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep2 === void 0 || (_crud$FieldFailureRep2 = _crud$FieldFailureRep2.data) === null || _crud$FieldFailureRep2 === void 0 ? void 0 : _crud$FieldFailureRep2.IsManual, showWarrantyDetails);
    var GeneralTab = __spreadArray(__spreadArray(__spreadArray([], BasicDetailsAndVehicleDetails, true), ProductDetailsCard, true), [{
            type: FormItemTypes.CardComponent,
            name: "RepairDetails",
            label: "Repair Details",
            columnSize: 12,
            sx: {
                border: '1px',
                borderRadius: "12px",
                borderColor: "secondary.200"
            },
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: "",
                    label: "",
                    columnSize: 12,
                    sx: {
                        backgroundColor: 'secondary.50'
                    },
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            elements: __spreadArray([], [{
                                    label: 'Branch',
                                    fieldName: 'BranchName'
                                }, {
                                    label: 'Job card number',
                                    fieldName: 'JobCardNumber'
                                }, {
                                    label: 'Part',
                                    fieldName: 'PartName',
                                    fieldCode: 'PartCode',
                                    divider: true
                                }, {
                                    label: 'Vendor name',
                                    fieldName: 'VendorName'
                                }, {
                                    label: 'Repair Type',
                                    fieldName: 'RepairType'
                                }, {
                                    label: 'Repair date',
                                    fieldName: 'RepairDate',
                                    date: true
                                }, {
                                    label: 'Date of failure',
                                    fieldName: 'DateOfFailure',
                                    date: true
                                }, {
                                    label: 'KM reading',
                                    fieldName: 'KMReading'
                                }, {
                                    label: 'Report date',
                                    fieldName: 'ReportDate'
                                }, {
                                    label: 'Reported by',
                                    fieldName: 'Reporter'
                                }, {
                                    label: 'Reporter mobile number',
                                    fieldName: 'ReporterContact'
                                }, {
                                    label: 'Parts replaced',
                                    fieldName: 'PartsReplaced'
                                }, {
                                    label: 'Vehicle status after repair',
                                    fieldName: 'VehicleStatusAfterRepair'
                                }].map(function (item) { return item !== null && item !== void 0 && item.divider ? {
                                type: FormItemTypes.Typography,
                                label: item.label,
                                name: item.fieldName,
                                disabled: true,
                                setFieldProps: function (formValues, currValue, field) {
                                    return {
                                        type: FormItemTypes.Typography,
                                        children: /*#__PURE__*/ React.createElement(Box, {
                                            sx: {
                                                ml: {
                                                    xs: 10,
                                                    sm: '0px',
                                                    md: '0px'
                                                },
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                width: '70%'
                                            }
                                        }, /*#__PURE__*/ React.createElement(Box, {
                                            sx: {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }
                                        }, formValues[item.fieldName] || '-'), /*#__PURE__*/ React.createElement(Divider, {
                                            orientation: "vertical",
                                            flexItem: true,
                                            sx: {
                                                borderColor: 'text.tertiary',
                                                height: '16px',
                                                alignSelf: 'center'
                                            }
                                        }), /*#__PURE__*/ React.createElement(Box, {
                                            sx: {
                                                whiteSpace: 'nowrap'
                                            }
                                        }, formValues[item === null || item === void 0 ? void 0 : item.fieldCode] || '-')),
                                        labelTypographyProps: {
                                            mb: {
                                                xs: '0px',
                                                sm: '4px',
                                                md: '4px'
                                            },
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        containerProps: {
                                            display: 'flex',
                                            direction: {
                                                xs: 'row',
                                                sm: 'column',
                                                md: 'column'
                                            },
                                            justifyContent: {
                                                xs: 'space-between',
                                                sm: 'normal'
                                            }
                                        }
                                    };
                                },
                                xs: 12,
                                sm: 6,
                                md: 3
                            } : {
                                // Desktop view
                                type: FormItemTypes.Typography,
                                label: item.label,
                                name: item.fieldName,
                                disabled: true,
                                pb: {
                                    xs: 0,
                                    sm: 1,
                                    md: 1
                                },
                                xs: 12,
                                sm: 6,
                                md: 3,
                                labelTypographyProps: {
                                    mb: {
                                        xs: '0px',
                                        sm: '4px',
                                        md: '4px'
                                    },
                                    noWrap: true,
                                    fontWeight: 'medium',
                                    fontSize: 'sm'
                                },
                                containerProps: {
                                    display: 'flex',
                                    direction: {
                                        xs: 'row',
                                        sm: 'column',
                                        md: 'column'
                                    },
                                    justifyContent: {
                                        xs: 'space-between',
                                        sm: 'normal'
                                    }
                                },
                                valueGetter: function (formValues, field) {
                                    var _field$name, _field$name2;
                                    return item !== null && item !== void 0 && item.date ? formValues !== null && formValues !== void 0 && formValues[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : '']).format('DD MMM, YYYY') : '-' : (formValues === null || formValues === void 0 ? void 0 : formValues[item.fieldName]) || '-';
                                }
                            }; }), true)
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: "customerComplaint",
            label: "Customer complaint",
            columnSize: 12,
            sx: {
                border: '1px',
                borderRadius: "12px",
                borderColor: "secondary.200",
                mb: 9
            },
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: "",
                    label: "",
                    columnSize: 12,
                    sx: {
                        backgroundColor: 'secondary.50'
                    },
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            elements: __spreadArray([], [{
                                    label: 'Problem Description',
                                    fieldName: 'ProblemDescription'
                                }, {
                                    label: 'Temperature Condition',
                                    fieldName: 'TemperatureConditionName'
                                }, {
                                    label: 'Vehicle speed',
                                    fieldName: 'VehicleSpeed'
                                }, {
                                    label: 'Road Condition',
                                    fieldName: 'RoadCondition'
                                }].map(function (item) { return ({
                                // Desktop view
                                type: FormItemTypes.Typography,
                                label: item.label,
                                name: item.fieldName,
                                disabled: true,
                                pb: {
                                    xs: 0,
                                    sm: 1,
                                    md: 1
                                },
                                xs: 12,
                                sm: 6,
                                md: 3,
                                labelTypographyProps: {
                                    mb: {
                                        xs: '0px',
                                        sm: '4px',
                                        md: '4px'
                                    },
                                    noWrap: true,
                                    fontWeight: 'medium',
                                    fontSize: 'sm'
                                },
                                containerProps: {
                                    display: 'flex',
                                    direction: {
                                        xs: 'row',
                                        sm: 'column',
                                        md: 'column'
                                    },
                                    justifyContent: {
                                        xs: 'space-between',
                                        sm: 'normal'
                                    }
                                },
                                valueGetter: function (formValues, field) {
                                    var _field$name3, _field$name4;
                                    return item !== null && item !== void 0 && item.date ? formValues !== null && formValues !== void 0 && formValues[(_field$name3 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name3 !== void 0 ? _field$name3 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name4 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name4 !== void 0 ? _field$name4 : '']).format('DD MMM, YYYY') : '-' : (formValues === null || formValues === void 0 ? void 0 : formValues[item.fieldName]) || '-';
                                }
                            }); }), true)
                        }]
                }, {
                    type: FormItemTypes.SearchSelect,
                    label: "Performance",
                    name: "PerformanceCodeId",
                    value: null,
                    required: true,
                    displayExpr: "Name",
                    valueExpr: "id",
                    apiRequest: {
                        Name: "Performance"
                    },
                    getListData: getDefectList,
                    getOptionLabel: function (option) { return option ? "".concat(option.ComplaintName, " - ").concat(option.ComplaintCode) : ""; }
                }, {
                    type: FormItemTypes.SearchSelect,
                    label: "Defect",
                    name: "DefectCodeId",
                    value: null,
                    required: true,
                    displayExpr: "Name",
                    valueExpr: "id",
                    apiRequest: {
                        Name: "Part Defect Code"
                    },
                    getListData: getDefectList,
                    getOptionLabel: function (option) { return option ? "".concat(option.ComplaintName, " - ").concat(option.ComplaintCode) : ""; }
                }]
        }], false);
    var formState = [{
            type: FormItemTypes.ContainerItem,
            name: "PageHeader",
            columnSize: 12,
            justifyContent: 'space-between',
            spacing: 0,
            p: 1,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: 5,
                    md: true,
                    lg: true,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(LeftArrow, null),
                            sx: {
                                color: 'secondary.600'
                            },
                            columnSize: 0,
                            onClick: function () {
                                handBackClick();
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: "DocumentName",
                            label: "",
                            columnSize: 0,
                            fontSize: "xxl",
                            fontWeight: "strong"
                        }, {
                            type: FormItemTypes.Chip,
                            name: "Status",
                            value: null,
                            columnSize: true,
                            color: "primary",
                            sx: {
                                marginTop: '3px',
                                marginLeft: '5px'
                            }
                        }, !lgMode ? {
                            type: FormItemTypes.Button,
                            name: 'More',
                            children: /*#__PURE__*/ React.createElement(MoreVert, null),
                            size: 'small',
                            variant: 'text',
                            color: 'secondary',
                            sx: {
                                p: '7px'
                            },
                            columnSize: 0,
                            setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                var action;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Menu',
                                                containerProps: {
                                                    anchorEl: e.target.parentElement
                                                },
                                                Component: ActionMenuList,
                                                componentProps: {
                                                    items: [{
                                                            id: "ResendToDealer",
                                                            children: "Resend to dealer"
                                                        }, {
                                                            id: 'download',
                                                            children: 'Download'
                                                        }, {
                                                            id: 'share',
                                                            children: 'Share'
                                                        }, {
                                                            id: 'print',
                                                            children: 'Print'
                                                        }, {
                                                            id: 'quick links',
                                                            children: 'Quick links'
                                                        }]
                                                }
                                            }))];
                                        case 1:
                                            action = _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        } : null]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: true,
                    md: true,
                    lg: true,
                    spacing: 0,
                    item: false,
                    gap: 1,
                    justifyContent: {
                        xs: "space-between",
                        sm: 'end'
                    },
                    alignContent: 'center',
                    elements: lgMode ? [{
                            type: FormItemTypes.Typography,
                            name: "DocumentName",
                            label: "DOC NO :",
                            value: '-',
                            containerProps: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                display: "inline-flex",
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            },
                            xs: 12,
                            sm: true,
                            md: true,
                            lg: true
                        }, {
                            type: FormItemTypes.Typography,
                            name: "DocumentDate",
                            label: "DOC DATE:",
                            containerProps: {
                                display: "inline-flex",
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            },
                            columnSize: 0,
                            valueGetter: function (formValues, field) {
                                var _field$name5;
                                var value = formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name5 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name5 !== void 0 ? _field$name5 : ""];
                                if (value) {
                                    return dayjs(value).format("DD MMM, YYYY");
                                }
                                return dayjs().format("DD MMM, YYYY");
                            }
                        }] : [{
                            type: FormItemTypes.Typography,
                            name: "DocumentName",
                            label: "DOC NO :",
                            value: '-',
                            containerProps: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                display: "inline-flex",
                                alignItems: "baseline",
                                gap: 1,
                                mx: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                mx: 1,
                                noWrap: true
                            },
                            xs: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: "DocumentDate",
                            label: "DOC DATE:",
                            value: '-',
                            containerProps: {
                                display: "inline-flex",
                                mx: 1,
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                mx: 1,
                                noWrap: true
                            },
                            xs: 12,
                            valueGetter: function (formValues, field) {
                                var _field$name6, _field$name7;
                                return formValues !== null && formValues !== void 0 && formValues[(_field$name6 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name6 !== void 0 ? _field$name6 : ""] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name7 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name7 !== void 0 ? _field$name7 : ""]).format("DD MMM, YYYY") : "-";
                            }
                        }]
                }]
        }, lgMode ? {
            type: FormItemTypes.Box,
            name: "",
            height: "68px",
            padding: "16px 24px",
            gap: "12px",
            bgcolor: secondary[100],
            mt: 2,
            borderTop: "1px solid ",
            borderBottom: "1px solid ",
            borderColor: secondary[200],
            columnSize: 12,
            justifyContent: "space-between",
            display: "flex",
            elements: [{
                    type: FormItemTypes.Box,
                    name: "",
                    columnSize: 3
                }, {
                    type: FormItemTypes.Box,
                    name: "",
                    justifyContent: "end",
                    display: "flex",
                    columnSize: 9,
                    gap: "12px",
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            variant: "text",
                            children: "Quick links",
                            columnSize: 0,
                            sx: {
                                bgcolor: "transparent",
                                fontWeight: "medium"
                            },
                            startIcon: /*#__PURE__*/ React.createElement(LinkSvg, null)
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(Download, null),
                            columnSize: 0,
                            variant: "outlined",
                            disabled: true,
                            sx: {
                                padding: "8px"
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement("img", {
                                src: ShareIcon,
                                alt: "shareicon",
                                loading: "lazy"
                            }),
                            columnSize: 0,
                            variant: "outlined",
                            disabled: true,
                            sx: {
                                padding: "8px"
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                            columnSize: 0,
                            variant: "outlined",
                            disabled: true,
                            sx: {
                                padding: "8px"
                            }
                        }, {
                            type: FormItemTypes.Box,
                            name: "",
                            columnSize: 0,
                            height: "100%",
                            width: "1px",
                            bgcolor: "rgba(0,0,0,0.1)",
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: 'AfrSave',
                            label: "",
                            children: "Save",
                            columnSize: 0,
                            variant: "contained",
                            color: "primary",
                            setFormState: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, {
                                            IsSubmit: 1
                                        }];
                                });
                            }); },
                            onClick: function () {
                                return __awaiter(this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        return [2 /*return*/, 'submit'];
                                    });
                                });
                            }
                        }]
                }]
        } : null, {
            type: FormItemTypes.ContainerItem,
            name: "",
            columnSize: 12,
            spacing: 0,
            containerProps: {
                spacing: 0
            },
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: "Tabs",
                    tabs: [{
                            id: "0",
                            label: "General",
                            elements: GeneralTab,
                            containerProps: {
                                px: 3
                            }
                        }, {
                            id: "1",
                            label: "Physical Phenomena",
                            containerProps: {
                                px: lgMode ? 3 : 0
                            },
                            elements: lgMode ? PhysicalFormData : PhysicalFormDataMobileView
                        }, {
                            id: "2",
                            label: "Additional info",
                            elements: AdditionalTab,
                            containerProps: {
                                px: 3
                            }
                        }, {
                            id: "3",
                            label: "Checklist",
                            containerProps: {
                                px: 3
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: "",
                                    columnSize: 12,
                                    spacing: 0,
                                    columnGap: 1.5,
                                    alignItems: "center",
                                    py: 2.5,
                                    px: 2,
                                    elements: [{
                                            type: FormItemTypes.Custom,
                                            name: "ChecklistFeedbackData",
                                            columnSize: 12,
                                            element: CheckListDataGrid
                                        }]
                                }]
                        }, {
                            id: "4",
                            label: "History",
                            containerProps: {
                                px: lgMode ? 3 : 0
                            },
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: "",
                                    columnSize: 12,
                                    element: HistoryTab
                                }]
                        }, {
                            id: "5",
                            label: "Child FFR",
                            containerProps: {
                                px: lgMode ? 3 : 0
                            },
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: "",
                                    columnSize: 12,
                                    element: ChildFF
                                }]
                        }],
                    valueExpr: "id",
                    displayExpr: "label",
                    columnSize: 12,
                    variant: "scrollable",
                    sx: {
                        margin: "0px 24px"
                    }
                }]
        }, !lgMode ? {
            type: FormItemTypes.ContainerItem,
            name: 'Footer',
            columnSize: 12,
            justifyContent: 'end',
            spacing: 0,
            sx: {
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                padding: 2,
                backgroundColor: 'background.paper',
                borderTop: '1px solid',
                borderColor: 'divider',
                zIndex: 1
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: "form-submit",
                    children: "Save",
                    columnSize: 0,
                    variant: "contained",
                    color: "primary",
                    setFormState: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, {
                                    IsSubmit: 1
                                }];
                        });
                    }); },
                    sx: {
                        mr: 1
                    },
                    onClick: function () {
                        return __awaiter(this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, 'submit'];
                            });
                        });
                    }
                }]
        } : null];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formState,
        getFormAPI: FieldFailureReportsGetAPI,
        getKey: FieldFailureReportsKeys.get,
        getRequest: {
            id: id
        },
        gridProps: {
            spacing: 0
        },
        mode: "edit",
        updateFormAPI: getFieldFailureReportsUpdateAPICall,
        updateKey: FieldFailureReportsKeys.update,
        updateRequest: {
            id: id
        }
    }));
};
export default FieldFailureReport;
